<script setup>
defineProps({
    icon: String,
    title: String,
    description: String,
})
</script>

<template>
    <div class="flex gap-8 justify-center items-center">
        <div class="flex flex-col gap-4 w-1/2">
            <i :class="`${icon} text-roori-blue`" style="font-size: 1.875rem"></i>
            <p class="text-xl font-bold">{{ title }}</p>
            <p class="leading-6">{{description}}</p>
            <div class="border-b border-blue-500 border-2" style="width: 48px;"></div>
        </div>
        <div class="w-1/3 xl:w-1/4 bg-neutral-100 rounded-xl p-4">
            <slot></slot>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
